/** 设备类型兜底（与后端默认内置类型一致） */
export const DEVICE_TYPE_PRESETS = [
  '市电远传',
  '市电透传远传',
  '低功耗远传',
  '压力远传',
  '自定义类型'
]